import { render } from "./Edit25Liquidation3.vue?vue&type=template&id=467460a0"
import script from "./Edit25Liquidation3.vue?vue&type=script&lang=js"
export * from "./Edit25Liquidation3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__